//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CdnImage from "../Image/CdnImage";

export default {
    name: 'AppSponsors',

    components: {CdnImage},

    computed: {

        heightFactor() {
            if (this.$breakpoint.xsOnly) {
                return 0.5
            }

            return this.$breakpoint.smAndDown ? 0.75 : 1
        }
    }
}
